{
  "name": "avs-gold-erp",
  "version": "1.1.1",
  "description": "AVS Gold ERP â€” Professional Jewellery Manufacturing ERP by Arivahly Venture Sphere",
  "author": {
    "name": "Arivahly Venture Sphere",
    "url": "https://arivahly.in/"
  },
  "private": true,
  "sideEffects": false,
  "type": "module",
  "scripts": {
    "dev": "node scripts/dev-egress-guard.mjs && vite",
    "build": "vite build",
    "build:erp": "node scripts/build-surfaces.mjs erp",
    "build:portal": "node scripts/build-surfaces.mjs portal",
    "postbuild": "node scripts/generate-sitemap.mjs",
    "upload:sourcemaps": "traceway-sourcemaps --url http://localhost --directory ./dist",
    "sitemap": "node scripts/generate-sitemap.mjs",
    "build:dev": "vite build --mode development",
    "preview": "vite preview --outDir dist --port 3000 --strictPort --host",
    "preview:shop": "vite preview --outDir dist --port 3000 --strictPort --host",
    "lint": "eslint .",
    "lint:ci": "eslint src/components/mobile src/lib/mobile src/hooks/use-device-class.ts src/routes/mobile.index.tsx src/routes/mobile.master.tsx src/routes/mobile.transactions.tsx src/routes/mobile.assistant.tsx src/routes/mobile.stock-entry.tsx src/components/portal/PortalMobileBottomNav.tsx src/components/design-system/TabletSplitView.tsx scripts/validate-migrations.mjs scripts/ci-notify.mjs",
    "typecheck": "tsc --noEmit",
    "security:scan": "node scripts/security-scan.mjs",
    "check:ui": "node scripts/check-ui-rules.mjs",
    "validate:migrations": "node scripts/validate-migrations.mjs",
    "i18n:coverage": "node scripts/check-i18n-coverage.mjs",
    "test:service": "node scripts/test-assistant-verification.mjs && node scripts/run-day1-selfchecks.mjs && node scripts/audit-report-print-sources.mjs",
    "ci:notify": "node scripts/ci-notify.mjs",
    "ci": "npm run typecheck && npm run lint:ci && npm run security:scan && npm run validate:migrations && npm run test:service && npm run qa:gold && npm run build",
    "format": "prettier --write .",
    "test:e2e": "playwright test",
    "test:e2e:headed": "playwright test --headed",
    "test:e2e:report": "playwright show-report e2e/report",
    "qa": "node qa/scripts/orchestrator.mjs",
    "qa:autonomous": "node qa/scripts/master-autonomous-orchestrator.mjs",
    "qa:deep": "node qa/scripts/master-autonomous-orchestrator.mjs",
    "qa:smoke": "node qa/scripts/orchestrator.mjs smoke",
    "qa:vibe": "node qa/scripts/run-vibe-testing.mjs",
    "qa:unit": "vitest run",
    "qa:unit:watch": "vitest",
    "qa:e2e": "playwright test --config=qa/e2e/playwright.qa.config.ts --project=chromium",
    "qa:e2e:smoke": "playwright test e2e/tests/core-flows-smoke.spec.ts e2e/tests/auth-login.spec.ts --config=qa/e2e/playwright.qa.config.ts --project=chromium",
    "qa:cross-browser": "playwright test --config=qa/e2e/playwright.qa.config.ts --grep-invert=@visual-only",
    "qa:visual": "cross-env QA_VISUAL_ENABLED=1 playwright test qa/visual --config=qa/e2e/playwright.qa.config.ts --project=desktop-1440",
    "qa:accessibility": "playwright test qa/accessibility/axe-smoke.spec.ts --config=qa/e2e/playwright.qa.config.ts --project=chromium",
    "qa:localization": "vitest run qa/localization",
    "qa:security": "node qa/scripts/orchestrator.mjs security",
    "qa:security:semgrep": "node qa/scripts/run-semgrep.mjs",
    "qa:security:gitleaks": "node qa/scripts/run-gitleaks.mjs",
    "qa:security:trivy": "node qa/scripts/run-trivy.mjs",
    "qa:security:zap": "node qa/scripts/run-zap.mjs",
    "qa:security:zap:auth": "node qa/scripts/run-zap.mjs --auth",
    "qa:security:strix": "node qa/scripts/run-strix.mjs quick",
    "qa:security:strix:deep": "node qa/scripts/run-strix.mjs deep",
    "qa:security:authenticated": "node qa/security/authenticated-security-validator.mjs",
    "qa:security:adversarial": "node qa/security/adversarial-security-suite.mjs",
    "qa:performance": "lhci autorun --config=qa/performance/lighthouserc.json",
    "qa:load:smoke": "node qa/scripts/run-k6.mjs smoke",
    "qa:load:normal": "node qa/scripts/run-k6.mjs normal",
    "qa:payments": "vitest run qa/payments",
    "qa:database:rls": "vitest run qa/database",
    "qa:gold": "vitest run qa/unit/gold",
    "qa:accounting": "vitest run qa/unit/accounting",
    "qa:full": "node qa/scripts/orchestrator.mjs full",
    "qa:release": "node qa/scripts/orchestrator.mjs release",
    "qa:guard": "node qa/scripts/staging-guard.mjs generic-check",
    "qa:install:docker": "node qa/scripts/docker-pull-images.mjs",
    "qa:install": "node qa/scripts/install-qa-tools.mjs",
    "qa:exploratory": "node qa/exploratory/run-all-exploratory-passes.mjs"
  },
  "dependencies": {
    "@capacitor/app": "^8.1.1",
    "@capacitor/camera": "^8.2.3",
    "@capacitor/filesystem": "^8.1.3",
    "@capacitor/haptics": "^8.0.2",
    "@capacitor/local-notifications": "^8.3.1",
    "@capacitor/preferences": "^8.0.1",
    "@capacitor/push-notifications": "^8.1.2",
    "@capacitor/share": "^8.0.1",
    "@capgo/capacitor-social-login": "^8.5.0",
    "@radix-ui/react-alert-dialog": "^1.1.15",
    "@radix-ui/react-checkbox": "^1.3.3",
    "@radix-ui/react-dialog": "^1.1.15",
    "@radix-ui/react-dropdown-menu": "^2.1.16",
    "@radix-ui/react-label": "^2.1.8",
    "@radix-ui/react-select": "^2.2.6",
    "@radix-ui/react-separator": "^1.1.8",
    "@radix-ui/react-slot": "^1.2.4",
    "@radix-ui/react-switch": "^1.2.6",
    "@radix-ui/react-tabs": "^1.1.13",
    "@radix-ui/react-toggle": "^1.1.10",
    "@radix-ui/react-tooltip": "^1.2.8",
    "@supabase/supabase-js": "^2.108.2",
    "@tailwindcss/vite": "^4.2.1",
    "@tanstack/react-query": "^5.83.0",
    "@tanstack/react-router": "^1.168.25",
    "@tanstack/react-virtual": "^3.14.4",
    "@tanstack/router-plugin": "^1.167.28",
    "@tracewayapp/react": "^1.2.0",
    "bwip-js": "^4.11.4",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cmdk": "^1.1.1",
    "date-fns": "^4.1.0",
    "exceljs": "4.4.0",
    "firebase": "^12.18.0",
    "jsbarcode": "^3.12.3",
    "jspdf": "^4.2.1",
    "lucide-react": "^0.575.0",
    "pdfjs-dist": "^4.10.38",
    "qrcode": "^1.5.4",
    "react": "^19.2.0",
    "react-dom": "^19.2.0",
    "recharts": "^2.15.4",
    "sonner": "^2.0.7",
    "tailwind-merge": "^3.5.0",
    "tailwindcss": "^4.2.1",
    "tw-animate-css": "^1.3.4",
    "zod": "^3.24.2",
    "zustand": "^5.0.14"
  },
  "devDependencies": {
    "@axe-core/playwright": "^4.10.2",
    "@eslint/js": "^9.32.0",
    "@lhci/cli": "^0.15.1",
    "@playwright/test": "^1.61.1",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/react": "^16.3.0",
    "@tracewayapp/bundler-plugin": "^1.2.0",
    "@tracewayapp/sourcemap-upload": "^1.2.0",
    "@types/node": "^22.16.5",
    "@types/qrcode": "^1.5.6",
    "@types/react": "^19.2.0",
    "@types/react-dom": "^19.2.0",
    "@vitejs/plugin-react": "^5.2.0",
    "@vitest/coverage-v8": "^3.2.4",
    "concurrently": "^10.0.3",
    "crawlix": "^0.1.8",
    "cross-env": "^10.1.0",
    "eslint": "^9.32.0",
    "eslint-config-prettier": "^10.1.1",
    "eslint-plugin-prettier": "^5.2.6",
    "eslint-plugin-react-hooks": "^5.2.0",
    "eslint-plugin-react-refresh": "^0.4.20",
    "explorbot": "^0.4.4",
    "globals": "^15.15.0",
    "prettier": "^3.7.3",
    "typescript": "^5.8.3",
    "typescript-eslint": "^8.56.1",
    "vite": "^8.0.16",
    "vitest": "^3.2.4",
    "wait-on": "^9.0.10"
  },
  "overrides": {
    "uuid": "^11.1.1",
    "cookie": "^0.7.2",
    "qs": "^6.15.4",
    "nanoid": "^3.3.18",
    "brace-expansion": "^2.1.4",
    "browserslist": "^4.28.7",
    "js-yaml": "^4.3.1",
    "dompurify": "^3.4.13",
    "tmp": "^0.2.7",
    "extract-zip": "^2.0.1"
  }
}
